import { QueryObserverResult, useQuery } from 'react-query';
import useApiService from '../utilities/useApiService';
import { fetchReturnRequestItems } from '../utilities/returnRequestItems';

export const useFetchRequestItems = (
   pharmacyId: string,
   requestId: string
): [
   any | undefined,
   () => void,
   Omit<QueryObserverResult<any>, 'data' | 'refetch'>
] => {
   const { getMethod } = useApiService();

   const { data, refetch, ...state } = useQuery({
      queryKey: [`/pharmacies/${pharmacyId}/returnrequests/${requestId}/items`],
      queryFn: (context) => {
         if (!pharmacyId || !requestId) return [];
         return fetchReturnRequestItems(
            getMethod,
            pharmacyId,
            requestId,
            { signal: context.signal }
         );
      },
   });

   return [data, () => refetch({ cancelRefetch: true }), state];
};
